import React from "react";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import styled from "styled-components";

const AnimatedDiv = styled(motion.div)`
  position: relative;
  height: 100%;
`;

export const RightToLeftMotion = ({ show, children }) => {
  return (
    <AnimatePresence>
      {show && (
        <AnimatedDiv
          initial={{ x: "150%" }}
          animate={{ x: 0 }}
          exit={{ x: "150%" }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </AnimatedDiv>
      )}
    </AnimatePresence>
  );
};
